import Parse from 'parse'
export const deletePkg = (pkgId) => {
  //status를 deleted로 변경
  return new Promise((res, rej) => {
    new Parse.Object('EmoticonPackage', { id: pkgId })
      .set('status', 'deleted')
      .save()
      .then((pkg) => window.location.reload())
      .catch((err) => {
        rej(err.message)
      })
  })
}
